const BLANK_TEMPLATE_ID = 'e60ed8c8-bfe3-4282-a13f-00a325749eda';

export { BLANK_TEMPLATE_ID };
